import { render, staticRenderFns } from "./InviteRewards.vue?vue&type=template&id=d35a9162&scoped=true"
import script from "./InviteRewards.vue?vue&type=script&lang=js"
export * from "./InviteRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35a9162",
  null
  
)

export default component.exports